import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {useSelector} from "react-redux";
import Chip from "@mui/material/Chip";

const useSales = () => {

    let navigate = useNavigate();

    const authState = useSelector((state) => state.authReducer);

    const actions = {
        add: false,
        edit: (id) => false,
        delete: false,
    };

    return {
        actions
    }
};

export default useSales;
